export default {
  "*.*.*": {
    "*.disappearing": [{
      finalAttr: {
        opacity: 0
      },
      slot: 'initial',
      callback: function callback() {
        this.hide();
      }
    }]
  }
};